import { MenuButton as ChakraMenuButton } from '@chakra-ui/react';

type MenuButtonProps = React.ComponentProps<typeof ChakraMenuButton>;

const MenuButton = ({ children, ...props }: Readonly<MenuButtonProps>) => {
  return <ChakraMenuButton {...props}>{children}</ChakraMenuButton>;
};

export default MenuButton;
